import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6154 3.24359L15.2308 2.32051L15.6154 3.24359C15.8615 3.14103 16.1385 3.14103 16.3846 3.24359L26.8487 7.60363C26.9403 7.6418 27 7.73132 27 7.83056V11.0813C27 18.6192 22.7416 25.5102 16 28.882C9.2584 25.5102 5 18.6192 5 11.0813V7.83056C5 7.73131 5.05968 7.6418 5.15129 7.60363L15.6154 3.24359Z"
        stroke="#0090FF"
        stroke-width="2"
      />
      <path
        opacity="0.5"
        d="M12 11H20L12 19H20"
        stroke="#0090FF"
        stroke-width="2"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Svg;
